import React from "react"
import { Accordion } from "devextreme-react"
import { Item as AccordionItem } from "devextreme-react/accordion"

import { FaTable, FaChartBar } from "../../../fa-icons"
import ExpenseGrid from "./ExpenseGrid"
import ExpenseChart from "./ExpenseChart"
import { hasAccessTo } from "../../../authentication"
import { getAccordionState, setAccordionState } from "../../shared/utilities"

const Expense = ({ data }) => {
  const stateKey = "concur-expenses"
  const expenseId = data.id

  return (
    <Accordion
      collapsible={true}
      multiple={true}
      onInitialized={getAccordionState(stateKey)}
      onSelectionChanged={setAccordionState(stateKey)}
    >
      <AccordionItem
        icon={FaChartBar}
        title=" Chart"
        visible={hasAccessTo("concur.expense.chart")}
      >
        <ExpenseChart expenseId={expenseId} />
      </AccordionItem>
      <AccordionItem
        icon={FaTable}
        title=" Grid"
        visible={hasAccessTo("concur.expense.grid.r")}
      >
        <ExpenseGrid expenseId={expenseId} />
      </AccordionItem>
    </Accordion>
  )
}

export default Expense
